import react from 'react';
export const ComponentsContext = react.createContext();